export class LoggingRequest{
  message: string;
  severity: string;

  constructor(values: LoggingRequest) {
    Object.assign(this, values);
  }
}
